<template>
  <section>
    <navbar-public></navbar-public>
    <section class="ew-smaller-container ew-mb">
      <div class="ew-card">
        <h1 class="ew-section-header ew-section-header--no-margin">Contáctanos</h1>
        <p class="alert alert-danger ew-alert" role="alert" v-if="signinError">
         Su mensaje no pudo ser enviado. Intenta de nuevo.
        </p>
        <form @submit.prevent="sendMessage" class="ew-form">
          <div class="ew-form__row">
            <div class="ew-form__field">
              <label class="ew-label" for="ct-first">Nombre *</label>
              <input id="ct-first" type="text" class="ew-input ew-input--block" v-model="first_name" required>
            </div>
            <div class="ew-form__field">
              <label class="ew-label" for="ct-last">Apellido *</label>
              <input id="ct-last" type="text" class="ew-input ew-input--block" v-model="last_name" required>
            </div>
          </div>

          <div class="ew-form__row">
            <div class="ew-form__field">
              <label class="ew-label" for="ct-email">Email *</label>
              <input id="ct-email" type="email" class="ew-input ew-input--block" v-model="email" required>
            </div>
            <div class="ew-form__field">
              <label class="ew-label" for="ct-phone">Teléfono *</label>
              <input id="ct-phone" type="text" class="ew-input ew-input--block" v-model="phone" required>
            </div>
          </div>

          <div class="ew-form__row">
            <div class="ew-form__field">
              <label class="ew-label" for="ct-company">Nombre de tu negocio *</label>
              <input id="ct-company" type="text" class="ew-input ew-input--block" v-model="company_name" required>
            </div>
            <div class="ew-form__field">
              <label class="ew-label" for="ct-web">Sitio web</label>
              <input id="ct-web" type="text" class="ew-input ew-input--block" v-model="web">
            </div>
          </div>

          <div class="ew-form__row">
            <div class="ew-form__field">
              <label class="ew-label" for="ct-shipping">¿Ya estás haciendo envíos? *</label>
              <select id="ct-shipping" name="do_shipping" class="ew-input ew-input--block" required v-model="shipmets">
                <option value="" disabled selected>Selecciona una opción</option>
                <option value="1">Si</option>
                <option value="0">No</option>
              </select>
            </div>
            <div class="ew-form__field">
              <label class="ew-label" for="ct-comments">Comentarios *</label>
              <input id="ct-comments" type="text" class="ew-input ew-input--block" v-model="comments" required>
            </div>
          </div>

          <div class="ew-form__row" v-if="shipmets === '1'">
            <div class="ew-form__field">
              <label class="ew-label" for="ct-n-shipping">Envíos mensuales *</label>
              <input id="ct-n-shipping" type="number" class="ew-input ew-input--block" v-model="n_shipping" required>
            </div>
          </div>

          <div class="ew-form__actions">
            <router-link class="ew-btn-outline" v-if="islogin" to="/dashboard">Anterior</router-link>
            <router-link class="ew-btn-outline" v-else to="/">Anterior</router-link>
            <button class="ew-btn-primary" type="submit" :disabled="isSending">{{ isSending ? 'Enviando…' : 'Siguiente' }}</button>
          </div>
        </form>
      </div>
    </section>

     <footer-public></footer-public>
    <call-float-button></call-float-button>
  </section>
</template>

<script>
import axios from 'axios'
import commons from '../commons'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import NavbarPublic from './Header/NavbarPublic'
import FooterPublic from './Header/FooterPublic'
import CallFloatButton from './Header/CallFloatButton'

export default {
  name: 'Contact',
  data () {
    return {
      islogin:"",
      shipmets:"",
      signinError: false,
      first_name: '',
      last_name: '',
      company_name: '',
      email: '',
      phone: '',
      web: '',
      comments:'',
      n_shipping:0,
      isSending: false
    }
  },
  watch: {},
  methods: {
    sendMessage () {
      this.isSending = true
      this.signinError = false
      axios
        .post(`${commons.apiURL}/api/v1/contact`, {
          first_name: this.first_name,
          last_name: this.last_name,
          company_name: this.company_name,
          email: this.email,
          phone: this.phone,
          web: this.web,
          message: this.comments,
          number_shipment: this.n_shipping
        })
        .then(response => {
          if (this.islogin) {
            this.$router.push('/shipments')
          } else {
            this.$router.push('/thank-page')
          }
        })
        .catch(error => {
          this.signinError = true
        })
        .finally(() => {
          this.isSending = false
        })
    },
    ...mapActions(['getUser'])
  },
  computed: {
    ...mapGetters(['user'])
  },
  created () {

    this.islogin = (localStorage.getItem('ew-user-id'))?true:false;
    if (this.islogin) {
      axios
      .get(`${commons.apiURL}/api/v1/users/${localStorage.getItem('ew-user-id')}`)
      .then(response => {
        if (response.data) {
          this.first_name = response.data.firstName
          this.last_name = response.data.lastName
          this.email = response.data.email
          this.phone = response.data.phone
        }
      })
      .catch(error => {
        if (error.response.status === 404) {

        }
      })
    }

  },
  components: {
    'navbar-public': NavbarPublic,
    'footer-public': FooterPublic,
    'call-float-button': CallFloatButton
  }
}
</script>

<style scoped lang="scss">
@import "../assets/styles/app-tokens";
@import "../assets/styles/ew-components";

.ew-smaller-container { @include app-tokens; max-width: 760px; margin: 0 auto; }
.ew-mb { margin-bottom: 5rem; }

.ew-card { @include ew-card; padding: 1.5rem 1.75rem; }
.ew-btn-primary { @include ew-btn-primary; }
.ew-btn-outline { @include ew-btn-outline; }
.ew-alert { font-family: var(--app-font); border-radius: var(--app-radius-sm); margin-bottom: 1rem; }

.ew-form { display: flex; flex-direction: column; gap: 1rem; max-width: none; }
.ew-form__row { display: flex; flex-wrap: wrap; gap: 1rem; > .ew-form__field { flex: 1 1 220px; min-width: 0; } }
.ew-form__field { display: flex; flex-direction: column; gap: 0.4rem; }
.ew-form__actions { display: flex; justify-content: flex-end; gap: 0.6rem; margin-top: 0.5rem; }
.ew-label { font-family: var(--app-font); font-size: 0.8rem; font-weight: 700; color: var(--app-navy); }
.ew-input { @include ew-input; }
.ew-input--block { width: 100%; }

select.ew-input {
  background-image: url(../assets/images/down-arrow.png);
  background-repeat: no-repeat;
  background-position: 97% center;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
  padding-right: 2rem;

  &:invalid { color: var(--app-muted); }
}
option { color: #000; }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue